import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, from, take, throwError } from 'rxjs';
import { AuthService } from 'src/services/auth.service';
import { Store } from '@ngrx/store';
import { UserInfoState } from 'src/store/reducers/user-info.reducer';
import { updateUserInfo } from 'src/store/actions/user-info.action';

@Injectable({ providedIn: 'root' })
export class UnauthorizedInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);
    private store = inject<Store<{ userInfo: UserInfoState }>>(Store);

    public intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return from(this.handle(request, next));
    }

    private handle(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (request.url.startsWith('/api/')) {
            return next.handle(request).pipe(
                catchError((error) => {
                    if (error instanceof HttpErrorResponse && error.status === 401) {
                        this.store
                            .select((x) => x.userInfo)
                            .pipe(take(1))
                            .subscribe((userInfo) => {
                                if (userInfo) {
                                    alert('Session expired.\nYou will be signed out.');
                                    this.authService.logout();
                                    this.store.dispatch(updateUserInfo({ userInfo: null }));
                                }
                            });
                    }
                    return throwError(() => error);
                })
            );
        } else {
            return next.handle(request);
        }
    }
}
